<script>
    import * as api from "../api/reserve";

    export default {
        name: "reserve"
        ,data: function () {
            return {
                activity_id: null
                ,activity_background: ''
                ,activity_banner: []
                ,activity_notice: ''
            }
        }
        ,created: function() {
            if(
                this.isEmpty(this.$ls('activity_id'))
                && this.isEmpty(this.$route.params.activity_id)
            ){
                this.$dialog.alert({
                    message: '请重新进入预约首页'
                });
            }

            if(!this.isEmpty(this.$route.params.activity_id)){
                this.$ls('activity_id', this.$route.params.activity_id)
            }

            this.activity_id = this.$ls('activity_id');

            // 获取用户数据
            if(this.isEmpty(this.$ls('wechat_info'))){
                location.href = 'http://' + document.domain + '/api/wechat/info?back_url=' + location.href;
            }
        }
        ,methods: {
            getActivityBanner0: function() {
                let that = this;
                that.activity_background = [];
                api.getActivityBanner0(that.activity_id).then(function (res) {
                    that.activity_background = res.data.img_url;
                });
            }
            ,getActivityBanner1: function() {
                let that = this;
                that.activity_banner = [];
                api.getActivityBanner1(that.activity_id).then(function (res) {
                    that.activity_banner = res.data;
                });
            }
            ,getActivityNotice: function() {
                let that = this;
                that.activity_notice = [];
                api.getActivityNotice(that.activity_id).then(function (res) {
                    that.activity_notice = res.data.content;
                });
            }
        }
    }
</script>